import { TypedDocumentNode, gql } from "@apollo/client";
import { Capability } from "./types";

export type CapabilitiesQueryResponseType = {
  me: {
    id: string;
    capabilities: Capability;
    roles: string[];
    universityLegacyIds: string[];
  };
};

export const CAPABILITIES_QUERY: TypedDocumentNode<CapabilitiesQueryResponseType> = gql`
  query MeQuery {
    me {
      id
      capabilities {
        domains
        permissions
      }
      roles
      universityLegacyIds
    }
  }
`;

export type SectionLegacyIdsQueryResponseType = {
  me: {
    id: string;
    sectionLegacyIds: string[];
  };
};

export const SECTION_LEGACY_IDS_QUERY: TypedDocumentNode<SectionLegacyIdsQueryResponseType> = gql`
  query MeSectionLegacyIdsQuery {
    me {
      id
      sectionLegacyIds
    }
  }
`;
